import * as React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import NotesList from './notes/NotesList';


export default function NoteContainer({ children, page, openFrom = "page", isMobile, isHeaderVisible }) {
    const { isNotePopup, isNoteExpanded } = useSelector((state) => state.common);

    const [rightContentVisible, setRightContentVisible] = React.useState(false);
    const [rightContentWidth, setRightContentWidth] = React.useState(300); // Default width

    React.useEffect(() => { // Set the right content width based on the isNoteExpanded state
        if (isMobile) {
            setRightContentWidth('100%'); // Full width on mobile
        } else {
            setRightContentWidth(isNoteExpanded ? 500 : 300);
        }
    }, [isNoteExpanded, isMobile]);

    React.useEffect(() => {
        const hasNoteIdParam = new URLSearchParams(window.location.search).has("noteId");
        setRightContentVisible(isNotePopup || hasNoteIdParam);
        if (isMobile) {
            setRightContentWidth('100%'); // Full width on mobile
        } else {
            setRightContentWidth(300);
        }
    }, [isNotePopup, isMobile]);

    return (
        <>
            <Box
                display="flex"
                flexDirection={isMobile && rightContentVisible ? "column" : "row"}
                width="100%"
                sx={{
                    ...(openFrom === "dialog" && {
                        flex: 1,
                        minHeight: 0,
                        height: "100%",
                    }),
                }}
            >
                <Box
                    flex="1"
                    sx={{
                        transition: "margin-right 0.3s",
                        overflow: openFrom === "page" || isMobile ? "auto" : "hidden",
                        display: isMobile && rightContentVisible ? "none" : "flex",
                        flexDirection: "column",
                        minHeight: 0,
                        ...(openFrom === "dialog" && {
                            flex: 1,
                            minHeight: 0,
                            height: "100%",
                        }),
                    }}
                >
                    {children}
                </Box>

                {rightContentVisible && (
                    <Box
                        style={{
                            transition: "width 0.3s", // Smooth transition for width
                            width: rightContentWidth,
                            backgroundColor: "#fff",
                            overflow: "hidden",
                            flexShrink: 0, // Prevent shrinking
                            marginTop: openFrom === "page" ? (isMobile ? "0px" : "80px") : "16px",
                            ...(openFrom === "dialog" && { borderRadius: "4px" }),
                            ...(isMobile && {
                                position: "fixed",
                                top: isHeaderVisible ? "188px" : "58px", // Account for header height
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 1300,
                                width: "100%",
                                height: isHeaderVisible ? "calc(100vh - 80px)" : "calc(100vh - 50px)" // Subtract header height
                            }),
                        }}
                        sx={{
                            ...(openFrom === "dialog" && { boxShadow: 3 }),
                        }}
                    >
                        <Box padding={2}>
                            <NotesList
                                page={page}
                                openFrom={openFrom}
                                isMobile={isMobile}
                                isHeaderVisible={isHeaderVisible}
                            />
                        </Box>
                    </Box>
                )}
            </Box>
        </>
    )
}
